import { VerificationMode } from 'src/auth/enums';
import { type ModeConfig } from './types';

export const MODE_CONFIG: Record<VerificationMode, ModeConfig> = {
  [VerificationMode.Authenticator]: {
    cellCount: 6,
    allowOnlyNumbers: true,
    description: 'Enter the 6-digit code generated by your authenticator app.',
    submitButtonLabel: 'Verify Code',
    submittingButtonLabel: 'Verifying Code',
    switchLabel: 'Use Emergency Backup Code',
    helpButtonLabel: 'Having trouble signing in?',
    helpTitle: 'Need help?',
    helpItems: [
      'If you can’t access your authenticator app, sign in using an emergency backup code.',
      'If you’ve lost access to both your authenticator app and backup codes, please contact your administrator for help signing in.',
    ],
  },
  [VerificationMode.Backup]: {
    cellCount: 8,
    allowOnlyNumbers: false,
    description:
      'Enter one of the backup codes you saved when setting up two-factor authentication.',
    submitButtonLabel: 'Verify Backup Code',
    submittingButtonLabel: 'Verifying Backup Code',
    switchLabel: 'Use Authenticator App Instead',
    helpButtonLabel: 'Don’t have a backup code?',
    helpTitle: 'Lost your backup codes?',
    helpItems: [
      'Backup codes are generated when you enable two-factor authentication. Check your password manager or secure notes for saved codes.',
      'If you’ve lost access to both your authenticator app and backup codes, contact your administrator for help signing in.',
    ],
  },
};
